import React from "react";

const MoreOutlined = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 7.48763C10.6667 7.31249 10.7012 7.13907 10.7683 6.97728C10.8354 6.81549 10.9336 6.66849 11.0575 6.54468C11.1814 6.42087 11.3284 6.32267 11.4903 6.25569C11.6521 6.18871 11.8255 6.15425 12.0007 6.1543C12.1758 6.15434 12.3492 6.18888 12.511 6.25594C12.6728 6.32301 12.8198 6.42128 12.9436 6.54515C13.0674 6.66903 13.1656 6.81607 13.2326 6.9779C13.2996 7.13972 13.334 7.31316 13.334 7.4883C13.3339 7.84201 13.1933 8.1812 12.9431 8.43124C12.693 8.68129 12.3537 8.82172 12 8.82163C11.6463 8.82154 11.3071 8.68095 11.057 8.43077C10.807 8.1806 10.6666 7.84134 10.6667 7.48763ZM10.6667 12.0016C10.6667 11.648 10.8071 11.3089 11.0572 11.0588C11.3072 10.8088 11.6464 10.6683 12 10.6683C12.3536 10.6683 12.6927 10.8088 12.9428 11.0588C13.1928 11.3089 13.3333 11.648 13.3333 12.0016C13.3333 12.3553 13.1928 12.6944 12.9428 12.9444C12.6927 13.1945 12.3536 13.335 12 13.335C11.6464 13.335 11.3072 13.1945 11.0572 12.9444C10.8071 12.6944 10.6667 12.3553 10.6667 12.0016ZM10.6667 16.515C10.6667 16.3398 10.7012 16.1664 10.7683 16.0046C10.8354 15.8428 10.9336 15.6958 11.0575 15.572C11.1814 15.4482 11.3284 15.35 11.4903 15.283C11.6521 15.216 11.8255 15.1816 12.0007 15.1816C12.1758 15.1817 12.3492 15.2162 12.511 15.2833C12.6728 15.3503 12.8198 15.4486 12.9436 15.5725C13.0674 15.6964 13.1656 15.8434 13.2326 16.0052C13.2996 16.1671 13.334 16.3405 13.334 16.5156C13.3339 16.8693 13.1933 17.2085 12.9431 17.4586C12.693 17.7086 12.3537 17.8491 12 17.849C11.6463 17.8489 11.3071 17.7083 11.057 17.4581C10.807 17.2079 10.6666 16.8687 10.6667 16.515Z"
        fill="#4E5968"
      />
    </svg>
  );
};

export default MoreOutlined;
